<template>
  <div class="content">
    페이지번호 : <input v-model="list.pageNo" />
    <button @click="getData()">검색</button>

    <br/>
    <br/>
    총 갯수 : {{ list.totalCount }} 페이지 번호 : {{ list.pageNo }}
    <div v-for="(item,i) in list.items" :key=i>
      item = {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: {
        items: [],
        totalCount: 0,
        listSize : 10,
        pageNo : 1,
      },
    }
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {

      this.$ui.httpGetList(this.list
        , "/proc/N_OFFICE_MEM_SEL_LIST"
        , { iv_pgsize : this.list.listSize,
            iv_page : this.list.pageNo,
            iv_officename : '' }
        , ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", [])
        })

    }
  },
}
</script>